import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { isString } from '@jd/jmtd-tools/es/is';
import { addParams } from '@jd/jmtd-tools/es/url';
import ConfigConsumer from '@jd/jmtd/es/ConfigConsumer';
import { getLocale } from '@jd/jmtd/es/locale';
import { ajax } from '../tools/ajax';
var hostname = window.location.hostname;
var OnlineOrigin = 'http://ge.back.jd.com';
var PreOrigin = 'http://yufa-ge.back.jd.com';
var DevOrigin = 'http://dev-ge.back.jd.com';
var Dev1Origin = 'http://dev1-ge.back.jd.com';
var DefaultMockPrefix = 'http://bpp-api.jd.com/bppapi/goldEye';
var ComponentWebSiteMockPrefix = 'http://bpp-api.jd.com/bppapi/componentWebSite';
export var isOnline = hostname.indexOf('ge.jd.com') > -1;
var isDev = hostname.indexOf('dev007.fe.jd.com') > -1;
var isPre = hostname.indexOf('test007.fe.jd.com') > -1;
var isDev008 = hostname.indexOf('dev008.fe.jd.com') > -1;
var isLocal = hostname.indexOf('local.') > -1 || hostname === '127.0.0.1' || hostname === 'localhost';

function Url() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var path = arguments.length > 1 ? arguments[1] : undefined;

  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      mock = _ref.mock,
      _ref$mockPath = _ref.mockPath,
      mockPath = _ref$mockPath === void 0 ? path : _ref$mockPath,
      _ref$mockPrefix = _ref.mockPrefix,
      mockPrefix = _ref$mockPrefix === void 0 ? DefaultMockPrefix : _ref$mockPrefix;

  return {
    path: path,
    prefix: prefix,
    mock: mock ? mockPrefix + mockPath : null
  };
}

var overrideOrigin; // 复写的origin

var datamix = Url.bind(null, '/datamix');
var publicUrl = Url.bind(null, '/public');
var hjy = Url.bind(null, '/hjy');
var hjycenter = Url.bind(null, '/hjycenter');
export var geUrl = {
  getcxtdata: datamix('/cxt/getcxtdata', {
    mock: true,
    mockPath: '/rgb/cxtClassic',
    mockPrefix: ComponentWebSiteMockPrefix
  }),
  getPageInfo: hjy('/gep/api/rest/common/getPageInfo', {
    mock: true
  }),
  getBrand: datamix('/skuDims/getBrand'),
  getSaleMode: datamix('/skuDims/getSaleMode'),
  getCate: datamix('/skuDims/getCate'),
  getVender: datamix('/skuDims/getVender'),
  getShop: datamix('/skuDims/getShop'),
  getSaler: datamix('/skuDims/getSaler'),
  getBuyer: datamix('/skuDims/getBuyer'),
  getSku: datamix('/skuDims/getSku'),
  getDataAuth: publicUrl('/dataauth/getDataAuth'),
  pageInfo: hjycenter('/api/common/pageInfo'),
  getDimDatas: publicUrl('/esCommDims/getDimDatas')
};
export var geContext = {}; // 获取实际请求的url

export function getUrl(arg) {
  if (isString(arg)) {
    return arg;
  }

  var path = arg.path,
      prefix = arg.prefix,
      mock = arg.mock;
  var origin;
  var mockResult;

  if (isLocal) {
    origin = DevOrigin;

    if (mock) {
      mockResult = mock;
    }
  } else if (isOnline) {
    origin = OnlineOrigin;
  } else if (isDev) {
    origin = DevOrigin;
  } else if (isDev008) {
    origin = Dev1Origin;
  } else if (isPre) {
    origin = PreOrigin;
  } else {
    origin = DevOrigin;
  }

  return mockResult || "".concat(overrideOrigin || origin).concat(prefix).concat(path);
} // 覆盖默认请求url

export function setUrl(urlTable) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      origin = _ref2.origin;

  Object.assign(geUrl, urlTable);

  if (origin) {
    overrideOrigin = origin;
  }
} // 发起get请求

export function geGet(url) {
  var _window$GEP_MENU_ITEM, _window$GEP_MENU_ITEM2;

  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref3$params = _ref3.params,
      params = _ref3$params === void 0 ? {} : _ref3$params;

  var requestUrl = addParams(getUrl(url), _objectSpread(_objectSpread({}, params), {}, {
    menuId: (_window$GEP_MENU_ITEM = (_window$GEP_MENU_ITEM2 = window.GEP_MENU_ITEM) === null || _window$GEP_MENU_ITEM2 === void 0 ? void 0 : _window$GEP_MENU_ITEM2.id) !== null && _window$GEP_MENU_ITEM !== void 0 ? _window$GEP_MENU_ITEM : undefined
  }));
  return ajax({
    url: requestUrl,
    withCredentials: !requestUrl.includes('bpp-api.jd.com')
  }).then(function (result) {
    return result.body;
  });
} // 发起post请求

export function gePost(url) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref4$data = _ref4.data,
      data = _ref4$data === void 0 ? {} : _ref4$data,
      _ref4$header = _ref4.header,
      header = _ref4$header === void 0 ? {} : _ref4$header;

  var requestUrl = getUrl(url);
  return ajax({
    method: 'POST',
    url: requestUrl,
    data: data,
    header: header,
    withCredentials: !requestUrl.includes('bpp-api.jd.com')
  }).then(function (result) {
    return result.body;
  });
} // 全选值

export var AllOptionValue = -999999;
export var AllOptionValueNew = '-999999';
export var AllOptionLabel = /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref5) {
  var locale = _ref5.locale;
  return getLocale(locale).common.all;
});
export function setGeContext(cxt) {
  Object.assign(geContext, cxt);
}
export function getDucc(namespace, item) {
  var params = {
    itemId: item
  };
  return addParams("".concat(isOnline ? OnlineOrigin : PreOrigin, "/hjycenter/api/ducc/").concat(namespace), params);
}